(function() {
  window.cardXPService = {
    /**
     * Award XP to winning cards after a battle
     * @param {Object} data - Object containing twitchId and cardIds array
     * @param {string} data.twitchId - The winner's Twitch ID
     * @param {Array} data.cardIds - Array of winning card IDs
     * @returns {Promise} - Axios promise with XP award results
     */
    awardXP(data) {
      return axios.post('/api/card/xp/award.php', data);
    },

    /**
     * Calculate XP required for next level
     * Formula: level * 100
     * @param {number} level - Current level
     * @returns {number} - XP required to reach next level
     */
    getXPRequired(level) {
      return level * 100;
    },

    /**
     * Calculate progress percentage to next level
     * @param {number} currentXP - Current XP
     * @param {number} level - Current level
     * @returns {number} - Percentage (0-100)
     */
    getProgressPercentage(currentXP, level) {
      const xpRequired = this.getXPRequired(level);
      return Math.min(100, Math.round((currentXP / xpRequired) * 100));
    },

    /**
     * Calculate total XP needed to reach a specific level from level 1
     * @param {number} targetLevel - Target level
     * @returns {number} - Total XP needed
     */
    getTotalXPForLevel(targetLevel) {
      let total = 0;
      for (let i = 1; i < targetLevel; i++) {
        total += i * 100;
      }
      return total;
    }
  };
})();
